import React, { useState, useEffect, useContext } from "react";
import { Alert } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook } from "@fortawesome/free-solid-svg-icons";
import Page from "components/Page";
import Products from "components/Products";
import FeaturedProducts from "components/FeaturedProducts";
import Loading from "components/Loading";
import { QuoteIcon } from "components/Images";
import { StoreContext } from "components/StoreContext";
import Error from "containers/Error";
import HeadTags from "components/HeadTags";

const Partner = () => {
  const { store, StoreAPI } = useContext(StoreContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [partnerData, setPartnerData] = useState({
    code: null,
    description: null,
    image: null,
    nameFull: "",
    nameShort: "",
    quoteText: null,
    quoteAuthor: null,
    quoteAuthorTitle: null
  });
  const [ready, setReady] = useState(false);
  const [productCount, setProductCount] = useState(0);
  const path = window.location.pathname.substr(1).toLowerCase();

  useEffect(() => {
    if (store.loaded) {
      setLoading(true);
      setError(null);
      StoreAPI.get(path)
        .then(response => {
          setPartnerData({
            code: response.data.code,
            description: response.data.description,
            image: response.data.image,
            nameFull: response.data.nameFull,
            nameShort: response.data.nameShort,
            quoteText: response.data.quoteText,
            quoteAuthor: response.data.quoteAuthor,
            quoteAuthorTitle: response.data.quoteAuthorTitle
          });
          setReady(true);
        })
        .catch(err => {
          setError(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, store.loaded, partnerData.code]);

  if (error) {
    return <Error error={error} />;
  }
  return (
    <Page>
      {loading ? (
        <section className="partner">
          <div className="partner__loading">
            <Loading />
          </div>
        </section>
      ) : (
        <>
          <HeadTags title={partnerData.nameFull} />
          <section className="partner">
            <div className="partner__header">
              <div className="partner__image">
                <div
                  style={{
                    backgroundImage: `url('${partnerData.image}')`
                  }}
                />
              </div>
              <h1 className="partner__name">{partnerData.nameFull}</h1>
              {productCount > 0 && (
                <div className="partner__courses">
                  <FontAwesomeIcon icon={faBook} />
                  {`${productCount} Course${productCount !== 1 ? "s" : ""}`}
                </div>
              )}
            </div>
            <div className="partner__description">
              {error && <Alert color="danger">{error}</Alert>}
              <h2>{`About ${partnerData.nameFull}`}</h2>
              <div
                dangerouslySetInnerHTML={{ __html: partnerData.description }}
              />
              {partnerData.quoteText && (
                <blockquote>
                  <QuoteIcon />
                  <p>{partnerData.quoteText}</p>
                  {partnerData.quoteAuthor && (
                    <footer>
                      <span>{partnerData.quoteAuthor}</span>
                      {partnerData.quoteTitle && (
                        <cite>{partnerData.quoteTitle}</cite>
                      )}
                    </footer>
                  )}
                </blockquote>
              )}
            </div>
          </section>
        </>
      )}
      {ready && (
        <FeaturedProducts
          title={`${partnerData.nameShort} Featured Products`}
          endpoint={
            partnerData.code
              ? `featured?partner=${partnerData.code}`
              : `featured`
          }
        />
      )}
      {ready && (
        <Products
          title={partnerData.nameShort || partnerData.nameFull}
          partner={partnerData.code}
          ready={ready}
          returnProductCount={setProductCount}
        />
      )}
    </Page>
  );
};

// Partner.propTypes = {};

export default Partner;
